import { useMutation } from '@tanstack/react-query'

import type { AddCartItemPayload } from '../@types'
import { addCartItem } from '../api'

const useAddCartItem = () => {
  return useMutation({
    mutationKey: ['addCartItem'],
    mutationFn: (attributes: AddCartItemPayload['attributes']) =>
      addCartItem({
        type: 'cart',
        attributes,
      }),
  })
}

export default useAddCartItem
